module.exports = __webpack_public_path__ + "img/icon-1.07c9e326.svg";